import React from 'react';
import { Routes, Route } from "react-router-dom";
import EPortalEventLayout from '../Layout/EPortalEventindex';
import Dashboard from '../Components/ExhibitorPortalEvent/Dashboard';
import YourProgramming from '../Components/ExhibitorPortalEvent/YourProgramming'; 
import ExhibitorCreateprogramming  from '../Components/ExhibitorPortalEvent/ExhibitorCreateprogramming'; 
import SocialMedia  from '../Components/ExhibitorPortalEvent/SocialMedia'; 
import AddPost  from '../Components/ExhibitorPortalEvent/AddPost'; 
import GuestList  from '../Components/ExhibitorPortalEvent/GuestList'; 
import CatalogueListing  from '../Components/ExhibitorPortalEvent/CatalogueListing'; 
import CatalogueImage  from '../Components/ExhibitorPortalEvent/CatalogueImage'; 
import BoothDesign  from '../Components/ExhibitorPortalEvent/BoothDesign'; 
import ArtWork from '../Components/ExhibitorPortalEvent/ArtWork'; 
import ArtWorklisting  from '../Components/ExhibitorPortalEvent/ArtWorklisting'; 
import AddArtwork from '../Components/ExhibitorPortalEvent/AddArtwork'; 
import UpdateArtwork from '../Components/ExhibitorPortalEvent/UpdateArtwork'; 
import GalleryLanding from '../Components/ExhibitorPortalEvent/GalleryLanding'; 
import VirtualBooths from '../Components/ExhibitorPortalEvent/VirtualBooths'; 
import ViewBooth from '../Components/ExhibitorPortalEvent/ViewBooth'; 
import CreateVirtualbooth from '../Components/ExhibitorPortalEvent/CreateVirtualbooth'; 
import EditVirtualbooth from '../Components/ExhibitorPortalEvent/EditVirtualbooth'; 
import Resources from '../Components/ExhibitorPortalEvent/Resources'; 

export default function ExhibitorPortalEvent(){
    return(
        <Routes >
          <Route element={<EPortalEventLayout />}>
            <Route path="ExhibitorPortalEvent" element={<Dashboard />} />
            <Route path="dashboard/:id" element={<Dashboard />} />
            <Route path="yourprogramming" element={<YourProgramming />} />
            <Route path="ExhibitorCreateprogramming" element={<ExhibitorCreateprogramming />} />
            <Route path="SocialMedia/:payment_id" element={<SocialMedia />} />
            <Route path="AddPost/:id" element={<AddPost />} />
            <Route path="guestlist" element={<GuestList />} />
            <Route path="cataloguelisting" element={<CatalogueListing />} />
            <Route path="catalogueimage" element={<CatalogueImage />} />
            <Route path="boothdesign" element={<BoothDesign/>} />
            <Route path="artwork" element={<ArtWork/>} />
            <Route path="artworklisting" element={<ArtWorklisting/>} />
            <Route path="addartwork" element={<AddArtwork/>} />
            <Route path="updateartwork" element={<UpdateArtwork/>} />
            <Route path="gallerylanding" element={<GalleryLanding/>} />
            <Route path="virtualbooths/:id" element={<VirtualBooths/>} />
            <Route path="viewbooth/:id" element={<ViewBooth/>} />
            <Route path="createvirtualbooth/:id" element={<CreateVirtualbooth/>} />
            <Route path="editvirtualbooth/:id" element={<EditVirtualbooth/>} />
            <Route path="resources" element={<Resources/>} />
          </Route>
      </Routes>
    )
}